<template>
  <div class="shop-content">
    <div class="header-warp">
      <div>我的钱包</div>
    </div>
    <div class="account-box">
      <div class="item">
        <div class="price">{{withdrawable_money}}</div>
        <div class="name">可提现金额</div>
      </div>
      <div class="item">
        <div class="price">{{frozen_money}}</div>
        <div class="name">冻结金额</div>
      </div>
    </div>
    <div class="header-warp">
      <div>提现</div>
    </div>
    <div class="withdrawal-box">
      <van-field
        v-model="witPrice"
        center
        type="number"
        clearable
        placeholder="请输入提现金额">
        <template #button>
          <van-button size="small" @click="withdrawal" type="ponhu">申请提现</van-button>
        </template>
      </van-field>
      <div class="info" v-if="!showTxt">
        <p class="info-text">开户名：{{card.realname}}</p>
        <p class="info-text">开户行：{{card.bank}}</p>
        <p class="info-text">银行卡号：{{card.cardnum}}</p>
      </div>
      <div class="info" v-if="showTxt">请先使用当前手机号登录“胖虎奢侈品”APP进行绑卡操作后再申请提现</div>
    </div>
    <div class="header-warp">
      <div>资金明细</div>
    </div>
    <van-list v-if="!isEmpty" v-model="loading" :finished="finished" finished-text="已加载全部" @load="onReachBottom">
      <div class="info-box">
        <div class="item" v-for="(item, index) in money_list" :key="index">
          <div class="content">
            <div class="price">{{item.symbol}}{{item.trand_amt}}</div>
          </div>
          <div class="time-box">
            <div class="status">{{item.remark}}</div>
            <div class="time">{{item.datetime}}</div>
          </div>
        </div>
      </div>
    </van-list>
    <emptyData v-if="isEmpty" message="暂无明细"></emptyData>
    <div class="wrap-login" v-if="loginShow">
      <div class="login-con">
        <div class="close" @click="loginShow=false"></div>
        <div class="login">
          <div class="login-top">
            <p>手机号登录</p>
            <div>
              <input type="number" placeholder="输入手机号" v-model="loginForm.mobile">
            </div>
            <div class="yzm">
              <input type="text" placeholder="输入验证码" maxLength="6" v-model="loginForm.verificationCode">
              <button class="place" :disabled="disabled" @click="getCode">{{ttext}}</button>
            </div>
          </div>
          <div class="init" @click="login">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validatMobile } from '@/utils/validate'
import { getUserCard, getUserMoney, userCash } from '@/api/user'
import { sendVCode, quicklyLogin } from '@/api/login'
import EmptyData from '@/components/business/EmptyData'
import wxapi from '@/utils/wxApi'

export default {
  components: { EmptyData },
  data() {
    return {
      witPrice: '',
      withdrawable_money: 0,
      frozen_money: 0,
      card: {},
      money_list: [],
      loginForm : {
        mobile: '',
        verificationCode: '',
        channel: 2,
        userSource: 21,
        version: ''
      },
      knowType: false,
      ttext: '获取验证码',
      disabled: false,
      loginShow: false,
      page: 1,
      loading: false,
      finished: false,
      isEmpty: false,
      showTxt: false
    }
  },
  created () {
    wxapi.wxRegister(this.wxRegCallback)
    this.getUserCard()
    this.getUserMoney()
  },
  methods: {
    // 获取账户信息
    getUserCard() {
      getUserCard().then(res => {
        if(res.list.length > 0) {
          this.card = res.list[0]
          this.showTxt = false;
        } else {
          this.showTxt = true;
        }
      }).catch(error => {
        if(error == '401') {
          this.loginShow = true;
        }
      })
    },
    getUserMoney(refresh) {
      this.Loading = false;
      this.isEmpty = false;
      var criteria = {
        p: this.page,
        rows: 30
      }
      getUserMoney(criteria).then(res => {
        this.withdrawable_money = res.account
        this.frozen_money = res.frozen_money
        if(res.list.length == 0) {
          this.finished = true
        } else {
          this.money_list = [...this.money_list, ...res.list]
        }
        if (this.money_list.length == 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.loading = false
      }).catch(error => {
        if(error == '401') {
          this.loginShow = true;
        }
      })
    },
    // 加载更多
    onReachBottom () {
      setTimeout(() => {
        this.page++
        this.getUserMoney()
      }, 300)
    },
    withdrawal() {
      if(this.showTxt) {
        this.$toast('请先使用当前手机号登录“胖虎奢侈品”APP进行绑卡操作后再申请提现')
        return
      }
      if(!this.witPrice || this.witPrice==0) {
        this.$toast('请输入正确的提现金额')
        return
      }
      if(parseInt(this.witPrice) > parseInt(this.withdrawable_money)) {
        this.$toast('最大可提现金额为' + this.withdrawable_money)
        return
      }
      
      var data = { 
        bindid: this.card.bindid,
        trand_amt: this.witPrice
      }
      userCash(data).then(res => {
        if(res.code == 200) {
          this.$toast('提现申请成功!')
          this.getUserCard()
          this.page = 1;
          this.getUserMoney()
          this.witPrice = '';
        } else {
          this.$toast(res.msg)
        }
      }).catch(error => {
        if(error == '401') {
          this.loginShow = true;
        } else {
          this.$toast(error)
        }
      })
    },
    //获取验证码
    getCode () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let that = this
      let t = 60
      that.ttext = t + '秒后重试'
      that.disabled = true
      var timer = setInterval(function () {
        t--
        if (t > 0) {
          that.ttext = t + '秒后重试'
          that.disabled = true
        } else {
          that.disabled = false
          that.ttext = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      sendVCode({ mobile: this.loginForm.mobile }).then(res => {
        console.log(res)
      }).catch(error => {
        this.$toast(error.errMessage)
      })
    },
    // 登录
    login () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.loginForm.verificationCode) {
        this.$toast('请输入短信验证码')
        return
      }
      quicklyLogin(this.loginForm).then(res => {
        this.$toast('登录成功')
        this.loginShow = false
        this.$store.dispatch('LoginByUser', res.userToken)
        this.getUserCard()
      }).catch(error => {
        this.$toast(error.errMessage)
      })
    },
    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: '我的钱包',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/purchase/wallet',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: '我的钱包',
        desc: '胖虎奢侈品',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/purchase/wallet',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    }
  }
}
</script>

<style lang="less" scoped>
.shop-content {
  background-color: #ffffff;
}
.header-warp {
  height: .6rem;
  font-size: .32rem;
  font-weight: 500;
  color: #222222;
  line-height: .6rem;
  padding: 30px;
}
.account-box {
  padding: 10px 30px 30px;
  text-align: center;
  position: relative;
  display: flex;
  border-bottom:1px solid #ebedf0;
  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    .price {
      font-size: 44px;
      color: #222222;
      font-weight: 500;
    }
    .name {
      font-size: 24px;
      color: #999999;
      font-weight: 400;
    }
  }
}
.withdrawal-box {
  padding: 0 30px 30px;
  border-bottom:1px solid #ebedf0;
  .info {
    padding-top: 20px;
    font-size: .36rem;
    font-weight: 500;
    color: #222222;
    .info-text {
      height: .5rem;
      font-size: .32rem;
      font-weight: 400;
      line-height: .5rem;
      color: #222222;
    }
    p {
      margin-block-start: .1rem;
      margin-block-end: 0;
    }
  }
}
.info-box {
  padding: 0 30px;
  .item {
    border-bottom:1px solid #ebedf0;
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 100px;
    align-items: center;
    .content {
      .price {
        font-size: .42rem;
        font-weight: 500;
        color: #222222;
      }
      .num {
        font-size: .3rem;
        font-weight: 400;
        color: #222222;
      }
    }
    .time-box {
      .status {
        font-size: .32rem;
        font-weight: 500;
        color: #222222;
        text-align: right;
      }
      .time {
        font-size: .28rem;
        color: #999999;
      }
    }
  }
}
.van-cell {
  background: #F7F7F7;
}
.wrap-login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  .login-con {
    width: 582px;
    height: 638px;
    position: absolute;
    top: 19.5%;
    left: 50%;
    transform: translateX(-50%);
    .close {
      width: 57px;
      height: 81px;
      background: url('../../../assets/img/close.png');
      background-size: 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .login {
      width: 582px;
      height: 557px;
      background: white;
      border-radius: 12px;
      position: absolute;
      bottom: 0;
      left: 0;
      .login-top {
        width: 513px;
        height: 316px;
        margin: 44px auto;
        p {
          font-size: 32px;
          font-weight: 700;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
        p:nth-child(2) {
          font-size: 28px;
          font-weight: 400;
          color: #282828;
          line-height: 40px;
          margin-top: 19px;
        }
        input {
          width: 490px;
          height: 89px;
          text-align: left;
          background: #f7f7f7;
          font-size: 0.28rem;
          font-weight: 400;
          color: #282828;
          outline: none;
          border: none;
          padding: 0 0 0 0.25rem;
          border-radius: 0.12rem;
          position: absolute;
          top: 130px;
        }
        .yzm {
          border-radius: 0.12rem;
          color: #282828;
          font-weight: 400;
          outline: none;
          border: none;
          position: absolute;
          input {
            width: 280px;
            height: 89px;
            border-radius: 0.12rem;
            padding: 0 0 0 0.25rem;
            margin-top: 0;
          }
          .place {
            width: 196px;
            height: 89px;
            padding: 0;
            border-radius: 0.12rem;
            border: 1px solid #ffd133;
            color: #ffd133;
            background-color: #ffffff;
            float: right;
            text-align: center;
            line-height: 89px;
            font-size: 28px;
            position: absolute;
            left: 310px;
            top: 130px;
          }
        }
      }
      .init {
        width: 100%;
        height: 88px;
        background: #ffd133;
        color: #282828;
        font-size: 28px;
        line-height: 88px;
        color: rgba(40, 40, 40, 1);
        text-align: center;
        position: absolute;
        bottom: 0;
        border-bottom-left-radius: 0.12rem;
        border-bottom-right-radius: 0.12rem;
      }
    }
  }
}
</style>


